<template>
    <div>
        <router-view
            class="fiui-wrapper"
            keep-alive
            transition
            transition-mode="out-in">
        </router-view>
        <test-env v-if="isTestEnv"></test-env>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                isTestEnv:false
            }
        },
        created(){
            let host=window.location.host
            if(host=='one-test.zhongan.com' || host=='localhost:8084'){
                this.isTestEnv=true
            }
        },
        mounted(){

        }
    }
</script>



// WEBPACK FOOTER //
// app.vue?05ce3093